<template>
  <div id="titlePage">
    <div class="space"></div>
    <label
      >既存のファイルを選択<input
        type="file"
        id="exsistData"
        v-on:change="readData"
    /></label>
    <label
      >新規作成
      <input type="button" value="新規作成" v-on:click="newData" />
    </label>
    <label v-if="!isExpress"
      >アプリ概要 <input type="button" value="" v-on:click="expressOn"
    /></label>
    <label v-if="isExpress"
      >概要を閉じる <input type="button" value="" v-on:click="expressOFF"
    /></label>

    <section v-if="isExpress" id="express">
      <h3>何ができるの？</h3>
      <p>
        システム設計図（特にクラス図）を作るためのツールです。クラス図的なものを
      </p>
      <h3>機能・仕様</h3>
      <ul>
        <li>オフライン実行。どこでも使える</li>
        <li>最低限の機能。故に早い</li>
        <li>選べる矢印。故に見やすい</li>
        <li>やり直し（undo）・再試行（redo）機能</li>
      </ul>
      <h3>操作方法</h3>
      <p>
        図形を描く：左から２つ目のツールバーを選択し、画面に向かってマウスをドラッグします。
      </p>
      <canvas id="drawDiagram"> </canvas>
      <p>
        線を描く：右から１つめのツールバーを選択し、図形の両端にある点と点をクリックすると線で結べます。
      </p>

      <canvas id="drawLine"> </canvas>

      <h3>作者より</h3>
      <p>
        インターネットの設計図アプリが重いと感じていたので作りました。vuejsで作成しました（講義の最後で、vuejsの紹介されてたのでセーフですよね？）。vuejsは去年末から学び初めて、今ではかなり便利に感じてます。コンポーネントを上手に作れればメンテナンスが凄く楽になりそう。。ただコンポーネント指向を使いこなせるまでには時がかかりそうです。
      </p>
      <p>
        今回は実用する気満々で作ってます。ただ、本来のクラス図とは幾分か異なる仕様です。あまりUMLで設計した経験がないからでしょう。。個人的にはオブジェクトやメソッドの参照関係がわかるものを必要としていたので、そこを示せるものを作りました。
      </p>
      <ul>
        <li><u>欠陥について</u></li>
        <li>アップロードがファイル参照しかありません...</li>
        <li>
          デバッグ数が不足しています。つい最近まで線の描画が気まぐれだったくらいなので、探せばいくらでもバグが出ると思います。
        </li>
      </ul>
      <div class="space"></div>
    </section>
  </div>
</template>
<script>
import ArrowCam from "./arrowCanvas.js";

export default {
  name: "app",
  data() {
    return {
      fname: null,
      isExpress: false,
    };
  },
  methods: {
    readData: function (e) {
      const input = e.target;
      const reader = new FileReader();
      reader.onload = () => {
        this.$parent.superExtendData = JSON.parse(reader.result);
        //       console.log(JSON.parse(reader.result));
        this.$parent.fileName = input.value;
      };
      this.newData();
      reader.readAsText(input.files[0]);
    },
    expressOn: function () {
      this.isExpress = true;
      this.$nextTick(function () {
        this.canvasLecture();
      });
    },
    expressOFF: function () {
      this.isExpress = false;
    },
    newData: function () {
      this.$parent.isEditor = true;
      this.$parent.isTitle = false;
    },
    canvasLecture: function () {
      const ctxD = document.getElementById("drawDiagram").getContext("2d");
      const ctxL = document.getElementById("drawLine").getContext("2d");
      var wi = 10,
        he = 10,
        mv = 0;
      const classImg = new Image();
      classImg.src = require("../../img/class.png");
      const mouseImg = new Image();
      mouseImg.src = require("../../img/mouse.png");
      console.log(mouseImg, classImg, wi);
      mouseImg.onload = () => {
        const p1 = setInterval(() => {
          //console.log(mouseImg, classImg, wi);
          ctxD.fillStyle = "#ff6";
          wi += 10;
          he += 12;
          if (wi < 100) ctxD.fillRect(10, 10, wi, he);
          else {
            ctxD.drawImage(classImg, 10, 10, 100, 125);
          }
          if (wi < 110) ctxD.drawImage(mouseImg, wi + 10, he + 10, 10, 15);
          if (wi > 120) {
            ctxD.clearRect(0, 0, 300, 150);
            wi = 10;
            he = 10;
            mv = 0;
          }
          if (this.isExpress == false) clearInterval(p1);
        }, 200);
        const p2 = setInterval(() => {
          //console.log(mouseImg, classImg, wi);
          ctxL.clearRect(0, 0, 300, 150);
          ctxL.fillStyle = "#66f";
          ctxL.drawImage(classImg, 10, 10, 100, 125);
          ctxL.drawImage(classImg, 150, 10, 100, 125);
          if (wi < 30) ctxL.fillText("ポチッ", 90, 70);
          if (wi > 90) ctxL.fillText("ポチッ", 160, 70);

          if (wi > 20 && wi < 90) {
            mv += 10;
          }
          ctxL.drawImage(mouseImg, 94 + mv, 70, 10, 15);
          if (wi > 90) {
            ArrowCam(90, 70, 94 + mv, 70, [0, 2, -10, 2, -10, 6], ctxL);
          }
          if (this.isExpress == false) clearInterval(p1);
        }, 200);
      };
    },
  },
};
</script>

<style scoped lang="scss">
#titlePage {
  height: 97vh;
}
.space {
  height: 50px;
}
input {
  display: none;
}
label {
  font-size: 13pt;
  margin: 25px;
  padding: 5px;
  display: block;
  border-bottom: 2px solid #3a3;
  cursor: pointer;
  background-image: radial-gradient(closest-side, #fda085 0%, #f6f3f5 100%);
  &:hover {
    background-image: radial-gradient(closest-side, #45ff45 0%, #f6f3f5 100%);
  }
}
#express {
  text-align: left;
  canvas {
    width: 300px;
    height: 150px;
  }
}
</style>
